import { memo } from 'react';
import styled from 'styled-components';

import { ReactComponent as FreeQuestLogoSVG } from '@/resources/logos/freequest-logo.svg';

const FreeQuestLogo = ({ className }: { className?: string }) => (
    <a className={className} href="https://freequest.pl/" target="_blank" rel="noopener noreferrer">
        <FreeQuestLogoSVG />
    </a>
);

const Memoized = memo(FreeQuestLogo);
const Styled = styled(Memoized)``;

export default Styled;
